// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var OptionUtils$SmartcutsMacros = require("../../../bs-utils/src/OptionUtils.bs.js");
var Browser__Debugger$SmartcutsMacros = require("../browser/Browser__Debugger.bs.js");

var EventListener = {};

var methodName = "DOMDebugger.getEventListeners";

var Params = {};

var Result = {};

var GetEventListeners = {
  methodName: methodName,
  Params: Params,
  Result: Result
};

function getEventListeners(objectId, depth, pierce, tabId, extensionId, targetId, param) {
  var tmp = {
    objectId: objectId
  };
  if (depth !== undefined) {
    tmp.depth = Caml_option.valFromOption(depth);
  }
  if (pierce !== undefined) {
    tmp.pierce = Caml_option.valFromOption(pierce);
  }
  var params = tmp;
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName, params).then(function (result) {
              return Promise.resolve(OptionUtils$SmartcutsMacros.$neg$question$great(result, (function (prim) {
                                return prim.listeners;
                              })));
            });
}

exports.EventListener = EventListener;
exports.GetEventListeners = GetEventListeners;
exports.getEventListeners = getEventListeners;
/* Browser__Debugger-SmartcutsMacros Not a pure module */
